module.exports = __webpack_public_path__ + "static/media/Mano 2.ff456c77.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Mano 2.png
// module id = 184
// module chunks = 0